import React, { useEffect, useState } from "react";
import { useAuth } from "@wantable/Shared/Hooks";

const IMAGES_BASE_URL =
  "https://cl.wantable.com/image/upload/ar_1:1,c_crop,g_center/c_scale,w_800/c_crop,g_center,h_800,w_800/f_auto/fl_keep_iptc/";

interface IUserProps {
  onLogout: () => void;
  isLoggedIn: boolean;
}

const User = ({ isLoggedIn, onLogout }: IUserProps) => {
  const [userData, setUserData] = useState<any>(null);
  const { getUserData, logout } = useAuth();

  const getUser = async () => {
    const user = await getUserData();
    setUserData(user);
  };

  useEffect(() => {
    if (!isLoggedIn) return;
    getUser();
  }, [isLoggedIn]);

  if (!userData) return null;

  const getUserName = () => {
    if (!userData) return "";

    return `${userData?.first_name}!`;
  };

  return (
      <button role="button"
        type='button'
        name="user"
        className='btn slide-menu__control'
        data-action='' disabled>
        Hi, {getUserName()}
      </button>
  );
};

export default User;
